(function () {
  const HEADING_SELECTOR = [
    'h1',
    'h2',
    '.sib-heading',
    '.sfb-heading',
    '.senbeder-hero-carousel__title',
    '.senbeder-about__hero-content h1',
    '.senbeder-about__section-head h2',
    '.senbeder-about__proof-head h2',
    '[class*="__section-head"] h2',
    '[class*="section-title"]',
    '[class*="__heading"]',
    '[class*="-heading"]'
  ].join(',');

  const COPY_SELECTOR = [
    '.sib-subtitle',
    '.senbeder-hero-carousel__text',
    '.senbeder-about__hero-content > p:not(.senbeder-about__eyebrow)',
    '.senbeder-about__proof-head > p:not(.senbeder-about__eyebrow)',
    '.senbeder-about__section-head > p',
    '[class*="__section-head"] > p',
    '[class*="section-head"] > p',
    '[class*="hero-content"] > p:not([class*="eyebrow"]):not([class*="badge"]):not([class*="tag"])',
    '[class*="hero-copy"] > p:not([class*="eyebrow"]):not([class*="badge"]):not([class*="tag"])'
  ].join(',');

  const CONTENT_TITLE_SELECTOR = [
    'h3',
    'h4',
    '[class*="card"] h2',
    '[class*="card-title"]',
    '[class*="item-title"]',
    '[class*="feature-title"]'
  ].join(',');

  const CONTENT_COPY_SELECTOR = 'p, li';

  const IMAGE_EXCLUDE_PATTERN = /icon|logo|avatar|flag|payment|rating|swatch|spinner|placeholder/i;

  const LEFT_NOWRAP_TITLES = new Set([
    'BOOST PERFORMANCE',
    'CUSTOMER REVIEWS',
    'COMPLETE CERTIFICATES AND REPORTS'
  ]);

  const LEFT_ALIGNED_TITLES = new Set([
    'YAMAHA MT-07 2025+ UPGRADES'
  ]);

  const EYEBROW_SELECTOR = [
    '[class*="eyebrow"]',
    '[class*="kicker"]',
    '[class*="section-tag"]',
    '[class*="__tag"]',
    '[class*="-tag"]',
    '[class*="hero-tag"]',
    '[class*="hero-badge"]',
    '[class*="__badge"]',
    '[class*="-badge"]'
  ].join(',');

  const HEADING_CONTAINER_SELECTOR = [
    '[class*="section-head"]',
    '[class*="section_header"]',
    '[class*="section-header"]',
    '[class*="hero-content"]',
    '[class*="hero-copy"]',
    '[class*="intro-head"]'
  ].join(',');

  const EXCLUDE_SELECTOR = [
    '[data-senbeder-typography="independent"]',
    '.article-template__title',
    '.article-template__content',
    '#shopify-section-header',
    '.shopify-section-header',
    '.header-wrapper',
    'header.header',
    '#shopify-section-footer',
    '.shopify-section-footer',
    'footer.footer',
    'nav',
    '.header',
    '.footer',
    '.card',
    '.card-wrapper',
    '.product-card-wrapper',
    '.senbeder-product-card',
    '.senbeder-hero-carousel',
    '.spc-product-row',
    '.spc-cart',
    '.cart-item',
    '.jdgm-widget',
    '.shopify-app-block',
    'form',
    '.predictive-search',
    '.facets',
    '.pagination-wrapper'
  ].join(',');

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function shouldSkip(node) {
    if (!node) return true;
    if (node.closest(EXCLUDE_SELECTOR)) return true;
    const text = normalizeText(node.textContent);
    if (!text || text.length < 3) return true;
    if (node.querySelector('svg, img, input, select, textarea, button')) return true;
    if (node.matches('h2') && node.closest('[class*="card"]') && !node.closest('[class*="section-head"]')) return true;
    return false;
  }

  function isHeroHeading(node) {
    if (node.matches('.senbeder-hero-carousel__title, .banner__heading, .slideshow__heading')) return true;
    return Boolean(node.closest('[class*="hero"], [class*="carousel"], [class*="slideshow"], [class*="banner"]'));
  }

  function isLeftNowrapTitle(node) {
    return LEFT_NOWRAP_TITLES.has(normalizeText(node.textContent).toUpperCase());
  }

  function isLeftAlignedTitle(node) {
    return LEFT_ALIGNED_TITLES.has(normalizeText(node.textContent).toUpperCase());
  }

  function splitText(text) {
    const words = normalizeText(text).split(' ').filter(Boolean);
    if (!words.length) return null;
    if (words.length === 1) {
      return { white: words[0], red: '' };
    }
    const redCount = Math.max(1, Math.floor(words.length * 0.45));
    const splitIndex = Math.max(1, words.length - redCount);
    return {
      white: words.slice(0, splitIndex).join(' '),
      red: words.slice(splitIndex).join(' ')
    };
  }

  function normalizeAlignment(value, direction) {
    const alignment = (value || '').toLowerCase();
    if (alignment === 'center') return 'center';
    if (alignment === 'right') return 'right';
    if (alignment === 'left') return 'left';
    if (alignment === 'end') return direction === 'rtl' ? 'left' : 'right';
    if (alignment === 'start') return direction === 'rtl' ? 'right' : 'left';
    return '';
  }

  function getAlignment(node) {
    if (!node || typeof window.getComputedStyle !== 'function') return 'left';
    const styles = window.getComputedStyle(node);
    return normalizeAlignment(styles.textAlign, styles.direction) || 'left';
  }

  function isDarkSurface(node) {
    if (!node || typeof window.getComputedStyle !== 'function') return true;
    let current = node;

    while (current && current !== document.documentElement) {
      const color = window.getComputedStyle(current).backgroundColor;
      const match = color && color.match(/rgba?\((\d+)[,\s]+(\d+)[,\s]+(\d+)(?:[,/\s]+([\d.]+))?\)/i);

      if (match) {
        const alpha = match[4] === undefined ? 1 : Number(match[4]);
        if (alpha >= 0.2) {
          const luminance = (Number(match[1]) * 0.2126) + (Number(match[2]) * 0.7152) + (Number(match[3]) * 0.0722);
          return luminance < 170;
        }
      }

      current = current.parentElement;
    }

    return true;
  }

  function applyHeadingAlignment(node, alignment) {
    node.classList.remove(
      'senbeder-unified-align-left',
      'senbeder-unified-align-center',
      'senbeder-unified-align-right'
    );
    node.classList.add('senbeder-unified-align-' + alignment);
  }

  function isUsableEyebrow(node) {
    if (!node || node.closest(EXCLUDE_SELECTOR)) return false;
    if (node.matches('[class*="__tags"], [class*="-tags"], [class~="tags"]')) return false;
    if (!normalizeText(node.textContent)) return false;
    return !node.querySelector('input, select, textarea, button');
  }

  function findEyebrow(heading) {
    let sibling = heading.previousElementSibling;
    let checked = 0;

    while (sibling && checked < 4) {
      if (sibling.matches(EYEBROW_SELECTOR) && isUsableEyebrow(sibling)) return sibling;
      const nested = sibling.querySelector(EYEBROW_SELECTOR);
      if (isUsableEyebrow(nested)) return nested;
      if (sibling.matches('h1, h2')) break;
      sibling = sibling.previousElementSibling;
      checked += 1;
    }

    const container = heading.closest(HEADING_CONTAINER_SELECTOR);
    if (!container) return null;

    const candidates = Array.from(container.querySelectorAll(EYEBROW_SELECTOR));
    const preceding = candidates.filter((candidate) => {
      if (!isUsableEyebrow(candidate)) return false;
      return Boolean(candidate.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_FOLLOWING);
    });

    return preceding.length ? preceding[preceding.length - 1] : null;
  }

  function applyEyebrow(eyebrow, alignment) {
    if (!isUsableEyebrow(eyebrow)) return;
    eyebrow.classList.remove(
      'senbeder-unified-eyebrow--left',
      'senbeder-unified-eyebrow--center',
      'senbeder-unified-eyebrow--right'
    );
    eyebrow.classList.add('senbeder-unified-eyebrow');
    eyebrow.classList.add('senbeder-unified-eyebrow--' + alignment);
  }

  function applyHeadingPresentation(node) {
    const leftNowrap = !isHeroHeading(node) && isLeftNowrapTitle(node);
    const leftAligned = !isHeroHeading(node) && isLeftAlignedTitle(node);
    node.classList.toggle('senbeder-unified-nowrap-title', leftNowrap);
    const alignment = isHeroHeading(node) ? getAlignment(node) : (leftNowrap || leftAligned ? 'left' : 'center');
    applyHeadingAlignment(node, alignment);
    applyEyebrow(findEyebrow(node), alignment);
    if (leftNowrap) fitNoWrapTitle(node);
  }

  function fitNoWrapTitle(node) {
    if (!node || !node.parentElement) return;
    const rootStyles = window.getComputedStyle(document.documentElement);
    const desktopSize = parseFloat(rootStyles.getPropertyValue('--senbeder-editor-section-title-size')) || 40;
    const mobileSize = parseFloat(rootStyles.getPropertyValue('--senbeder-editor-section-title-mobile-size')) || desktopSize;
    let size = window.innerWidth < 750 ? mobileSize : desktopSize;
    node.style.setProperty('--senbeder-nowrap-size', size + 'px');

    if (window.innerWidth >= 750) return;

    const available = node.parentElement.clientWidth;
    while (size > 16 && node.scrollWidth > available) {
      size -= 1;
      node.style.setProperty('--senbeder-nowrap-size', size + 'px');
    }
  }

  function fitNoWrapTitles(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.senbeder-unified-nowrap-title').forEach(fitNoWrapTitle);
  }

  function applyHeading(node) {
    if (shouldSkip(node)) return;

    if (node.dataset.senbederHeadingSplit === 'true') {
      node.classList.remove('senbeder-unified-hero-title', 'senbeder-unified-section-title');
      node.classList.add(isHeroHeading(node) ? 'senbeder-unified-hero-title' : 'senbeder-unified-section-title');
      applyHeadingPresentation(node);
      return;
    }

    const parts = splitText(node.textContent);
    if (!parts) return;

    const white = document.createElement('span');
    white.className = 'senbeder-split-heading__white';
    white.textContent = parts.white;

    node.textContent = '';
    node.appendChild(white);

    if (parts.red) {
      const red = document.createElement('span');
      red.className = 'senbeder-split-heading__red';
      red.textContent = parts.red;
      node.appendChild(document.createTextNode(' '));
      node.appendChild(red);
    }

    node.classList.add('senbeder-split-heading');
    node.classList.remove('senbeder-unified-hero-title', 'senbeder-unified-section-title');
    node.classList.add(isHeroHeading(node) ? 'senbeder-unified-hero-title' : 'senbeder-unified-section-title');
    node.dataset.senbederHeadingSplit = 'true';
    applyHeadingPresentation(node);
  }

  function applyContentTitle(node) {
    if (!node || node.closest(EXCLUDE_SELECTOR)) return;
    if (!normalizeText(node.textContent)) return;
    if (!isDarkSurface(node)) return;
    node.classList.add('senbeder-unified-content-title');
  }

  function applyContentCopy(node) {
    if (!node || node.closest(EXCLUDE_SELECTOR)) return;
    if (node.matches(EYEBROW_SELECTOR)) return;
    if (!normalizeText(node.textContent)) return;
    if (!isDarkSurface(node)) return;
    node.classList.add('senbeder-unified-content-copy');
  }

  function applyResponsiveImage(node) {
    if (!node || node.closest(EXCLUDE_SELECTOR)) return;
    if (node.matches('.senbeder-oem-brand__hero-img')) {
      node.classList.remove('senbeder-unified-responsive-image');
      if (node.parentElement && node.parentElement.tagName === 'PICTURE') {
        node.parentElement.classList.remove('senbeder-unified-responsive-picture');
      }
      return;
    }
    const signature = [node.className, node.id, node.getAttribute('alt')].filter(Boolean).join(' ');
    if (IMAGE_EXCLUDE_PATTERN.test(signature)) return;
    node.classList.add('senbeder-unified-responsive-image');
    if (node.parentElement && node.parentElement.tagName === 'PICTURE') {
      node.parentElement.classList.add('senbeder-unified-responsive-picture');
    }
  }

  function applyLeadCopy(node) {
    if (!node || node.closest(EXCLUDE_SELECTOR)) return;
    if (!normalizeText(node.textContent)) return;
    if (!isDarkSurface(node)) return;
    node.classList.add('senbeder-unified-lead-copy');
  }

  function normalizeArticleBodyHeadings(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const articleTitle = document.querySelector('.article-template__title');
    const titleText = normalizeText(articleTitle?.textContent).toLowerCase();

    scope.querySelectorAll('.article-template__content h1').forEach((heading) => {
      if (normalizeText(heading.textContent).toLowerCase() === titleText) {
        heading.remove();
        return;
      }

      const replacement = document.createElement('h2');
      Array.from(heading.attributes).forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });
  }

  function run(root) {
    const scope = root || document;
    const main = scope.querySelector ? (scope.querySelector('#MainContent') || scope) : document;

    normalizeArticleBodyHeadings(main);
    main.querySelectorAll(HEADING_SELECTOR).forEach(applyHeading);
    main.querySelectorAll(CONTENT_TITLE_SELECTOR).forEach(applyContentTitle);
    main.querySelectorAll(CONTENT_COPY_SELECTOR).forEach(applyContentCopy);
    main.querySelectorAll('img').forEach(applyResponsiveImage);
    main.querySelectorAll(COPY_SELECTOR).forEach(applyLeadCopy);
    fitNoWrapTitles(main);

    main.querySelectorAll('.senbeder-split-heading').forEach((heading) => {
      const next = heading.nextElementSibling;
      if (next && /^(P|DIV)$/i.test(next.tagName) && !next.matches('[class*="actions"], [class*="button"], [class*="grid"]')) {
        applyLeadCopy(next);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document), { once: true });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));

  let resizeFrame;
  window.addEventListener('resize', () => {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(() => fitNoWrapTitles(document));
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => fitNoWrapTitles(document));
  }
})();
